// GridComponent.js
import React, { useState, useEffect } from 'react';

const StatsLevel = ({ items }) => {

  const [agiliteLvl, setAgiliteLvl] = useState(items.NiveauAgilité);
  const [forceLvl, setForceLvl] = useState(items.Niveau_Force);
  const [capMagiqueLvl, setCapMagiqueLvl] = useState(items.NiveauCapMagique);
  const [agilite, setAgilite] = useState(items.Agilité);
  const [force, setForce] = useState(items.Force);
  const [capMagique, setCapMagique] = useState(items.CapMagique);

  useEffect(() => {
    setAgilite(items.Agilité + ((items.NiveauAgilité-agiliteLvl)*30))
  }, [agiliteLvl, items]);
  useEffect(() => {
    setCapMagique(items.CapMagique + ((items.NiveauCapMagique-capMagiqueLvl)*30))
  }, [capMagiqueLvl, items]);
  useEffect(() => {
    setForce(items.Force + ((items.Niveau_Force-forceLvl)*30))
  }, [forceLvl, items]);

  const lvlStatPalierSelect =( niveaux) => {
    const select = [];
    for (let i = 0; i < niveaux ; i++) {
      select.push(<option className='red' key={niveaux-i} value={niveaux-i}>{niveaux-i}</option>);   
    }
    return select
  }

  return (
    <div className="grid margin">
      <div className="item Agilite">
        Agilité
      </div>
      <div className="item Force">
        Force
      </div>
      <div className="item CapMagique">
        Capacité Magique
      </div>

      <div className="item AgiliteFade">
        Lvl.
        {items.NiveauAgilité > 1 ? (
          <select  className='dropdown-stat' onChange={(e) => setAgiliteLvl(e.target.value)}>
            {lvlStatPalierSelect(items.NiveauAgilité)}
          </select>
        ) : (
          items.NiveauAgilité
        )}
      </div>

      <div className="item ForceFade">
        Lvl.
        {items.Niveau_Force > 1 ? (
          <select className='dropdown-stat'  onChange={(e) => setForceLvl(e.target.value)}>
            {lvlStatPalierSelect(items.Niveau_Force)}
          </select>
        ) : (
          items.Niveau_Force 
        )}
      </div>

      <div className="item CapMagiqueFade">
        Lvl.
        {items.NiveauCapMagique > 1 ? (
          <select className='dropdown-stat'   onChange={(e) => setCapMagiqueLvl(e.target.value)}>
            {lvlStatPalierSelect(items.NiveauCapMagique)}
          </select>
        ) : (
          items.NiveauCapMagique
        )}
      </div>

      <div className="item AgiliteFade2">{agilite}</div>
      <div className="item ForceFade2">{force}</div>
      <div className="item CapMagiqueFade2">{capMagique}</div>
    </div>
  );
};


export default StatsLevel;
